export function Standard() {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="24" height="24" rx="4" fill="#F8F8F8" />
      <rect x="1" y="1" width="24" height="24" rx="4" stroke="#EDEDED" strokeWidth="0.5" />
      <path
        d="M13 19C16.3137 19 19 16.3137 19 13C19 9.68629 16.3137 7 13 7C9.68629 7 7 9.68629 7 13C7 16.3137 9.68629 19 13 19Z"
        fill="url(#paint0_linear_2008_27289)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2008_27289"
          x1="16.5"
          y1="7"
          x2="10.5"
          y2="17.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B8B8BD" />
          <stop offset="1" stopColor="#D8D8DC" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function Advanced() {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="24" height="24" rx="4" fill="#EEF2FF" />
      <rect
        x="1"
        y="1"
        width="24"
        height="24"
        rx="4"
        stroke="url(#paint0_linear_2008_27292)"
        strokeWidth="0.5"
      />
      <path
        d="M11.5 19C13.9853 19 16 16.9853 16 14.5C16 12.0147 13.9853 10 11.5 10C9.01472 10 7 12.0147 7 14.5C7 16.9853 9.01472 19 11.5 19Z"
        fill="url(#paint1_linear_2008_27292)"
        fillOpacity="0.8"
      />
      <path
        opacity="0.8"
        d="M14.5 16C16.9853 16 19 13.9853 19 11.5C19 9.01472 16.9853 7 14.5 7C12.0147 7 10 9.01472 10 11.5C10 13.9853 12.0147 16 14.5 16Z"
        fill="url(#paint2_linear_2008_27292)"
        fillOpacity="0.8"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2008_27292"
          x1="1"
          y1="0.25"
          x2="24.25"
          y2="25.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3760FF" />
          <stop offset="1" stopColor="#96ABFF" stopOpacity="0.44" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2008_27292"
          x1="16.0466"
          y1="18.9534"
          x2="7.93971"
          y2="18.6258"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7A95FF" stopOpacity="0.29" />
          <stop offset="1" stopColor="#3760FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2008_27292"
          x1="19.0466"
          y1="15.9534"
          x2="10.9397"
          y2="15.6258"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7A95FF" stopOpacity="0.29" />
          <stop offset="1" stopColor="#3760FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function Premium() {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="24" height="24" rx="4" fill="#FFF8DC" />
      <rect
        x="1"
        y="1"
        width="24"
        height="24"
        rx="4"
        stroke="url(#paint0_linear_2008_27295)"
        strokeWidth="0.5"
      />
      <rect
        x="1"
        y="1"
        width="24"
        height="24"
        rx="4"
        stroke="url(#paint1_linear_2008_27295)"
        strokeWidth="0.5"
      />
      <path
        d="M10.7463 14.719L10.1102 18.4358C10.0694 18.6743 10.3132 18.8605 10.5326 18.7584L13.041 17.5903L15.5496 18.7584C15.7689 18.8606 16.0127 18.6744 15.9719 18.4359L15.3357 14.7143"
        fill="#FBBE00"
      />
      <path
        d="M17.432 11.5C17.432 13.9012 15.4674 15.85 13.041 15.85C10.6146 15.85 8.65 13.9012 8.65 11.5C8.65 9.09884 10.6146 7.15 13.041 7.15C15.4674 7.15 17.432 9.09884 17.432 11.5Z"
        fill="url(#paint2_linear_2008_27295)"
        stroke="url(#paint3_linear_2008_27295)"
        strokeWidth="0.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2008_27295"
          x1="1"
          y1="0.25"
          x2="24.25"
          y2="25.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3760FF" />
          <stop offset="1" stopColor="#96ABFF" stopOpacity="0.44" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2008_27295"
          x1="1"
          y1="0.25"
          x2="24.25"
          y2="25.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDD58" />
          <stop offset="1" stopColor="#F6BA00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2008_27295"
          x1="13.041"
          y1="7"
          x2="13.041"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDC45" />
          <stop offset="1" stopColor="#FBBE00" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2008_27295"
          x1="13.041"
          y1="7"
          x2="13.041"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD535" stopOpacity="0" />
          <stop offset="1" stopColor="#F9A100" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function Elite() {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="24" height="24" rx="4" fill="#E9FFEA" />
      <rect
        x="1"
        y="1"
        width="24"
        height="24"
        rx="4"
        stroke="url(#paint0_linear_2008_27298)"
        strokeWidth="0.5"
      />
      <rect
        x="1"
        y="1"
        width="24"
        height="24"
        rx="4"
        stroke="url(#paint1_linear_2008_27298)"
        strokeWidth="0.5"
      />
      <rect
        x="1"
        y="1"
        width="24"
        height="24"
        rx="4"
        stroke="url(#paint2_linear_2008_27298)"
        strokeWidth="0.5"
      />
      <path
        d="M8.67995 11.4L11.0788 13.5333L12.9978 9.79999L14.9168 13.5333L17.3156 11.4L16.3561 15.6667V17.8H9.63947V15.6667L8.67995 11.4Z"
        fill="url(#paint3_linear_2008_27298)"
      />
      <path
        d="M8.2002 9.8H8.20499M17.7954 9.8H17.8002M12.9978 8.2H13.0026M8.67995 11.4L11.0788 13.5333L12.9978 9.79999L14.9168 13.5333L17.3156 11.4L16.3561 15.6667V17.8H9.63947V15.6667L8.67995 11.4Z"
        stroke="url(#paint4_linear_2008_27298)"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2008_27298"
          x1="1"
          y1="0.25"
          x2="24.25"
          y2="25.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3760FF" />
          <stop offset="1" stopColor="#96ABFF" stopOpacity="0.44" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2008_27298"
          x1="1"
          y1="0.25"
          x2="24.25"
          y2="25.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDD58" />
          <stop offset="1" stopColor="#F6BA00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2008_27298"
          x1="1"
          y1="0.25"
          x2="24.25"
          y2="25.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#85FFB7" />
          <stop offset="1" stopColor="#60D895" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2008_27298"
          x1="13.0002"
          y1="8.2"
          x2="13.0002"
          y2="17.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5EBC94" />
          <stop offset="1" stopColor="#6AD876" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2008_27298"
          x1="13.0002"
          y1="8.2"
          x2="13.0002"
          y2="17.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5EBC94" />
          <stop offset="1" stopColor="#6AD876" />
        </linearGradient>
      </defs>
    </svg>
  );
}
